/**
 * Обрыв связи с сервером, а не ошибка бизнес-логики: браузер до API не
 * достучался. Чаще всего это перезапуск бэкенда при выкатке — он занимает
 * около полминуты, и менеджеру в этот момент показывали стек AxiosError.
 */
export const isConnectionError = (error) => {
  const message = error?.message || '';
  const code = error?.details?.code || '';
  return (
    message === 'Network Error' ||
    code === 'ERR_NETWORK' ||
    code === 'ECONNABORTED' ||
    /timeout/i.test(message)
  );
};
